import { render, staticRenderFns } from "./ButtonToggle.vue?vue&type=template&id=921d51c0&scoped=true&"
import script from "./ButtonToggle.vue?vue&type=script&lang=js&"
export * from "./ButtonToggle.vue?vue&type=script&lang=js&"
import style0 from "./ButtonToggle.vue?vue&type=style&index=0&id=921d51c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921d51c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
